import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "7",
  height: "13",
  viewBox: "0 0 7 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.528514 1.02729C0.788864 0.766944 1.21097 0.766944 1.47132 1.02729L6.47132 6.02729C6.73167 6.28764 6.73167 6.70975 6.47132 6.9701L1.47132 11.9701C1.21097 12.2305 0.788864 12.2305 0.528514 11.9701C0.268165 11.7098 0.268165 11.2876 0.528514 11.0273L5.05711 6.4987L0.528514 1.9701C0.268165 1.70975 0.268165 1.28764 0.528514 1.02729Z",
      fill: "#6E0AFA"
    }, null, -1)
  ])))
}
export default { render: render }